import Vue from "vue";
import Router from "vue-router";

import Layout from '@/layout'

import stockRouter from './modules/stock'
import reportRouter from './modules/report'
import retentionRouter from './modules/retention'
import miniAppRouter from './modules/mini_program'
import merchantRouter from './modules/merchants'
import companyRouter from './modules/compony'
import userRouter from './modules/user'
import businessChanceRouter from './modules/business_chances'

Vue.use(Router);

// 每一个route下的第一个childe组件是该route的首页，这个需要设置hidden为true,不在菜单中显示出来
// title对应i18n里面的值

/**
 * hidden:用于设置隐藏该路由不显示在菜单上的，如果不需要在菜单上显示，则设置hidden为true值，表示隐藏，否则就是可以显示在菜单上的
 * hiddeChilden：用于设置隐藏下级菜单的，如果不想显示自己的下级菜单则设置hiddeChilden为true,否则不设置
 * meta:该路由的菜单显示名字，字体类，该页面权限
 * roles:页面级权限，如果进入该页面需要权限，则设置该属性，如果不需要权限则不设置
 * module:用于标志当前页面所属那个模块，可用于高亮菜单
 */

export const constantRoutes = [
  // {
  //   path: "/",
  //   redirect:'/dashboard',
  //   component: Layout,
  //   hiddeChilden:false,
  //   hidden: true,
  //   meta: { title: 'menu.home', keepAlive: false, iconClass: 'el-icon-menu'},
  //   children:[
  //     {
  //       path: "/dashboard",
  //       name: "dashboard",
  //       hidden: true,
  //       component: () => import( "@/views/dashboard"),
  //       meta: { title: 'menu.home', module:'dashboard', keepAlive: false, iconClass: 'el-icon-menu'},
  //     },
  //   ]
  // },
  {
    path: "/",
    name: "dashboard",
    hiddeChilden: false,
    hidden: true,
    component: () => import("@/views/dashboard"),
    meta: { title: 'menu.home', module: 'dashboard', keepAlive: false, iconClass: 'el-icon-menu' },
  },
  {
    path: '/login',
    name: "login",
    hidden: true,
    component: () => import('@/views/login'),
    meta: { title: 'login.login', module: 'login', keepAlive: true, iconClass: 'el-icon-orange' },
  },
  {
    path: '/404',
    name: '404',
    hidden: true,
    component: () => import('@/views/error/404'),
    meta: { title: 'menu.error', module: '404', keepAlive: true, iconClass: 'el-icon-cloudy-and-sunny' },
  },
  {
    path: '/401',
    name: '401',
    hidden: true,
    component: () => import('@/views/error/401'),
    meta: { title: 'menu.authority', module: '401', keepAlive: true, iconClass: 'el-icon-unlock' },
  },
  // 费罗娜官网引用的表单
  {
    path: "/merchants/form",
    name: "merchantFrom",
    hidden: true,
    component: () => import("@/views/merchants/merchantsForm"),
    meta: { title: 'menu.merchants', iconClass: 'el-icon-files', module: 'merchants', keepAlive: true }
  }
]

export const ayscRoutes = [
  stockRouter,
  reportRouter,
  retentionRouter,
  miniAppRouter,
  merchantRouter,
  // companyRouter,
  // businessChanceRouter,
  userRouter,
  {
    path: "/merchants/unlimit/form",
    name: 'merchantUnlimitFormL',
    hiddeChilden: true,
    hidden: false,
    meta: { title: 'menu.merchantsRegistrar', iconClass: 'el-icon-files', module: 'merchants', roles:['MERCHANT_REGISTRAR']},
    component: Layout,
    children: [
      // 免权限登录可访问的表单
      {
        path: "",
        name: "merchantUnlimitForm",
        hidden: true,
        component: () => import("@/views/merchants/unlimiitMerchantForm"),
        meta: { title: 'menu.merchantsRegistrar', iconClass: 'el-icon-files', module: 'merchants', keepAlive: false, roles:['MERCHANT_REGISTRAR']},
      }
    ]
  },
  {
    path: '*',
    name: 'all',
    hidden: true,
    redirect: '/404',
  },
]
let organizaRoutes = [...constantRoutes, ...ayscRoutes]
const router = new Router({
  routes: organizaRoutes
});


// 重置路由
export function resetRouter() {
  const newRouter = new Router({
    routes: organizaRoutes
  });
  router.matcher = newRouter.matcher // reset router
}
export default router
